import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Selo compacto para inserir dentro de heros das páginas de vendas.
 * Variante "soft" combina com cores existentes; semântico via tokens.
 */
export function VelloClientBadge({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1 rounded-full',
        'bg-gradient-to-r from-amber-500/15 to-amber-500/10',
        'border border-amber-500/30',
        'text-amber-700 dark:text-amber-400 text-xs font-semibold',
        className,
      )}
    >
      <Sparkles className="h-3 w-3" aria-hidden="true" />
      Grátis para clientes Vello Sports
    </div>
  );
}
